import React from "react";

function QuadratinoColore(props) {
    
    const iDcolSel1 = props.iDcolSel1;
    const iDcolSel2 = props.iDcolSel2;
    const iDcolSel3 = props.iDcolSel3;
    const colore = props.colore
    const colSelChange=props.colSelChange
    const colNonSelChange=props.colNonSelChange
    const setColHover=props.setColHover
    
    //A Questo elemento passo il nome, la classe css è col-NOME ("col-"+nome)
    //la funzione deve essere questa: se il colore non è selezionato:
    //al clic controlla se col1 è libero e lo imposta, e così per ogni col e non fa niente se son tutti selezionati
    // se il colore è selezionato: il clic va a svuotare il valore col che combacia con il nome

    //console.log("colore.idPS1",colore.idPS1,"iDcolSel1",iDcolSel1,"colore.idPS2",colore.idPS2,"iDcolSel2",iDcolSel2,"colore.idPS3",colore.idPS3,"iDcolSel3",iDcolSel3)

    if (colore.idPS1 === iDcolSel1) {
        return(<div className={"material-icons md-13 quadratino sel col-"+colore.desc} onMouseEnter={() => setColHover(colore.desc)} onMouseLeave={() => setColHover("")} data-id={colore.idPS1} onClick={colSelChange}>done</div>)
    } else if (colore.idPS2 === iDcolSel2) {
        return(<div className={"material-icons md-13 quadratino sel col-"+colore.desc} onMouseEnter={() => setColHover(colore.desc)} onMouseLeave={() => setColHover("")} data-id={colore.idPS2} onClick={colSelChange}>done</div>)
    } else if (colore.idPS3 === iDcolSel3) {
        return(<div className={"material-icons md-13 quadratino sel col-"+colore.desc} onMouseEnter={() => setColHover(colore.desc)} onMouseLeave={() => setColHover("")} data-id={colore.idPS3} onClick={colSelChange}>done</div>)
    } else {
        return(<div className={"material-icons md-13 quadratino nosel col-"+colore.desc} onMouseEnter={() => setColHover(colore.desc)} onMouseLeave={() => setColHover("")} data-name={colore.desc} onClick={colNonSelChange}></div>)
    }

}

export default QuadratinoColore;